import { render, staticRenderFns } from "./HelloSolucion.vue?vue&type=template&id=7845089a"
import script from "./HelloSolucion.vue?vue&type=script&lang=js"
export * from "./HelloSolucion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports